import React, { RefObject } from 'react';
import classNames from 'classnames';

interface Props {
  dataTestID?: string;
  popoverRef?: RefObject<HTMLDivElement>;
  visible?: boolean;
  onClose?: () => void;
}

const getPopoverClassName = ({ visible }) =>
  classNames(
    'absolute',
    'shadow-lg',
    'rounded',
    'bg-white',
    'w-72',
    'border',
    'border-gray-350',
    'transition-opacity',
    'duration-300',
    'ml-10 after:tail-left-inset',
    {
      'block opacity-100 z-20': visible,
      'hidden opacity-0 -z-1': !visible,
    },
  );

const POPOVER_STYLE = {
  transform: 'translate(0, -47%)',
};

const TAIL_STYLE = {
  content: ' ',
  bottom: '50%',
  marginLeft: '-2.1rem',
  borderStyle: 'solid',
  borderWidth: '1.05rem',
  borderColor: 'transparent #cad5e4 transparent transparent',
  opacity: 1,
};

export const BillingCodesInfoPopover: React.FC<Props> = ({
  dataTestID,
  popoverRef,
  visible = false,
  onClose,
}) => {
  return (
    <div data-testid={dataTestID} ref={popoverRef}>
      <div className={getPopoverClassName({ visible })} style={POPOVER_STYLE}>
        <div className="absolute" style={TAIL_STYLE}>
          {' '}
        </div>
        <div className="text-left text-black text-sm font-normal normal-case px-4 pt-3 pb-2 whitespace-normal">
          <p className="font-extrabold text-gray-750 font-sansLight">
            If the code you are looking for is not present, please reach out to{' '}
            <a
              className="text-blue-200 font-black pointer-events-auto underline"
              href="mailto:billing@joinmodernhealth.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              billing@joinmodernhealth.com
            </a>{' '}
          </p>
        </div>
      </div>
    </div>
  );
};
